import React, { useState, useEffect  } from 'react';
import { Link } from 'react-router-dom';
import * as Constants from '../../constants';
import DynamicIcon from '../dynamicicon';

const PublicHeader =({page})=>{
   
    const [open, setOpen] = useState(false);
    return ( <div class="nav">
        <img src={`${Constants.baseurl}/assets/landing/logo.png`}  alt="Logo" />
        <div className="hamburger" onClick={() => setOpen(!open)}>
    <span><DynamicIcon iname="menu"/></span>
    <span>.</span>
    <span>.</span>
  </div>
        <nav class="nav-links" className={`nav-links ${open ? "active" : ""}`}>
      
      <Link to={'/'} className={`dropdown ${page=='home'?'active':''}`}>Home</Link>
  
      <Link to={'/aboutus'} className={`dropdown ${page=='aboutus'?'active':''}`}>About Us</Link>
      <div className={`dropdown ${page=='news'?'active':''}`} >
        <a href="#">News </a>
      </div>
      <div  className={`dropdown ${page=='probate'?'active':''}`}>
        <a href="#">Probate Pub </a>
      </div>
      <div  className={`dropdown ${page=='media'?'active':''}`} >
        <a href="#">Media </a>
      </div>
      <div className={`dropdown ${page=='directories'?'active':''}`}>
      <a href="#">Directories </a>
      </div>
      <div  className={`dropdown ${page=='divisions'?'active':''}`}>
       <a href="#">Divisions </a>
      </div>
      <div  className={`dropdown ${page=='causelist'?'active':''}`}>
      <a href="#">Cause Lists </a>
      </div>
      
      <Link to="/login">JIS/E-Filing</Link>
    </nav>
    <div class="call-btn">
      
      <Link to="/login">Login/Create Account</Link>
    </div>

</div>)
  }

  export default PublicHeader;